<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Update Courtsey Groups</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="group_name"
                type="text"
                name="group_name"
                id="group_name"
              />
              <label>Group Name</label>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="group_desc"
                type="text"
                name="group_desc"
                id="group_desc"
              />
              <label>Description</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="cg_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="courtsey-groups"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      btenable: false,
      cg_id: null,
      group_name: "",
      group_desc: "",
      cg_is_active: "Y",
      submitted: false,
    };
  },
  mounted() {},
  beforeMount() {
    const { cg_id } = this.$route.query;
    if (cg_id) {
      this.cg_id = cg_id;
      this.getItemsDetails(cg_id);
    }
  },
  methods: {
    getItemsDetails(cg_id) {
      let loader = this.$loading.show();
      let payload = {
        cg_id: cg_id,
      };
      MarketingService.GetSingleCourtseyGroup(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            const { group_name, cg_id, group_desc, cg_is_active } =
              data.Records[0];
            this.group_name = group_name;
            this.group_desc = group_desc;
            this.cg_id = cg_id;
            this.cg_is_active = cg_is_active;
          } else {
            this.$toasted.show(data.message || "Unable to fetch data");
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.group_name) {
        return this.$toasted.show("Please Enter Size Name");
      } else {
        let loader = this.$loading.show();
        let payload = {
          cg_id: this.cg_id,
          group_name: this.group_name,
          group_desc: this.group_desc,
          cg_is_active: this.cg_is_active || "Y",
        };
        MarketingService.UpdateCourtseyGroups(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              if (redirect) {
                this.$router.push({
                  path: "courtsey-groups",
                });
              }
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    resetForm: function () {
      this.cg_id = null;
      this.group_name = "";
      this.group_desc = "";
      this.cg_is_active = "Y";
      this.btenable = false;
      this.submitted = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CourtseyComponents/CourtseyGroups/editGroups.vue